var _require = require('./simplify_claims'),
    simplifyClaims = _require.simplifyClaims;

var simplify = require('./simplify_text_attributes');

var simplifySitelinks = require('./simplify_sitelinks');

var simplifyEntity = function simplifyEntity(entity, options) {
  var simplified = {
    id: entity.id,
    type: entity.type,
    modified: entity.modified
  };
  simplifyIfDefined(entity, simplified, 'labels');
  simplifyIfDefined(entity, simplified, 'descriptions');
  simplifyIfDefined(entity, simplified, 'aliases');

  if (entity.claims != null) {
    simplified.claims = simplifyClaims(entity.claims, options);
  }

  if (entity.sitelinks != null) {
    simplified.sitelinks = simplifySitelinks(entity.sitelinks, options);
  }

  return simplified;
};

var simplifyIfDefined = function simplifyIfDefined(entity, simplified, attribute) {
  if (entity[attribute] != null) {
    simplified[attribute] = simplify[attribute](entity[attribute]);
  }
};

var simplifyEntities = function simplifyEntities(entities) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (entities.entities) entities = entities.entities;
  var entityPrefix = options.entityPrefix;
  return Object.keys(entities).reduce(function (obj, key) {
    var entity = entities[key];
    if (entityPrefix) key = "".concat(entityPrefix, ":").concat(key);
    obj[key] = simplifyEntity(entity, options);
    return obj;
  }, {});
};

module.exports = {
  simplifyEntity: simplifyEntity,
  simplifyEntities: simplifyEntities
};